import clsx from 'clsx';

type CallToBookLinkProps = {
  phone: string;
  className?: string;
  showPhoneIcon?: boolean;
};

export const CallToBookLink = ({
  phone,
  className,
  showPhoneIcon = false,
}: CallToBookLinkProps) => (
  <a
    className={clsx(
      'flex w-full items-center justify-center rounded-lg bg-primary-main p-2 text-white !no-underline ring-1 ring-primary-main hover:bg-primary-light hover:ring-primary-light',
      className
    )}
    href={`tel:${phone}`}
    aria-label="call to book"
  >
    <div className="w-fit">
      <div className="flex flex-row items-center justify-between gap-2">
        {showPhoneIcon && (
          <svg
            className="h-5 w-5"
            viewBox="0 0 18 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <g clipPath="url(#clip0_call_to_book)">
              <path
                d="M17.4291 23.1482C17.4842 22.833 17.3891 22.4928 17.144 22.1776L13.737 18.0052H13.707C13.5869 17.8551 13.4118 17.7401 13.1517 17.64C12.7915 17.4999 12.4313 17.5149 12.0661 17.65L10.305 18.4905L10.1299 18.5255C10.0349 18.5155 10.0099 18.5205 9.97485 18.4955L9.69469 18.3104C9.51959 18.1953 9.29946 18.0002 8.99929 17.695C8.72413 17.3899 8.36392 16.9496 7.97369 16.3643C7.58347 15.7789 7.18824 15.0135 6.75799 14.0729C6.32775 13.1324 6.01757 12.3519 5.82746 11.6966C5.63735 11.0412 5.52228 10.4909 5.47225 10.0806C5.40722 9.61037 5.41222 9.18512 5.46225 8.84493C5.48726 8.80991 5.50227 8.74487 5.5473 8.67483C5.59232 8.60479 5.64735 8.56477 5.67237 8.55976L7.19325 7.85936C7.47341 7.74429 7.67352 7.54918 7.82861 7.27903C7.9837 7.00887 8.05374 6.74872 8.02372 6.45355L7.36835 0.975394C7.32832 0.770276 7.25828 0.575163 7.13321 0.420074C7.01314 0.264985 6.86806 0.139913 6.66794 0.0598664C6.40779 -0.0401912 6.11262 -0.0101739 5.83246 0.109895L1.72009 1.99598C1.52498 2.06602 1.33987 2.1961 1.13475 2.38621C0.959654 2.57131 0.81457 2.75142 0.704507 2.95654C0.679492 2.99156 0.619458 3.12663 0.5194 3.38678C0.394328 3.65194 0.289267 4.03716 0.209221 4.53745C0.0991579 5.04274 0.0441262 5.65809 0.00910607 6.38851C-0.0259141 7.11893 0.0241147 7.95442 0.159193 8.92497C0.29427 9.89553 0.509394 10.9662 0.844588 12.1668C1.17978 13.3675 1.68507 14.6833 2.36546 16.1141C3.18594 17.9402 4.06644 19.451 4.94195 20.6617C5.82246 21.8724 6.67295 22.818 7.4584 23.5634C8.23885 24.2838 8.94425 24.8041 9.53459 25.1643C10.1449 25.4945 10.5802 25.7096 10.8754 25.8297C11.0054 25.8647 11.1005 25.9048 11.1655 25.9198L11.2956 25.9548C11.5157 25.9998 11.7609 26.0098 12.026 25.9898C12.2912 25.9698 12.5213 25.8897 12.7114 25.7897L16.8038 23.9386C17.129 23.7535 17.3491 23.4984 17.4291 23.1482Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_call_to_book">
                <rect width="18" height="26" fill="currentColor" />
              </clipPath>
            </defs>
          </svg>
        )}
        <span className="ut-md whitespace-nowrap font-semibold capitalize text-inherit">
          Call To Book
        </span>
      </div>
    </div>
  </a>
);
